import React from "react"
import { StyledSpacer } from "./styles"

const Spacer = ({ transparent }) => <StyledSpacer transparent={transparent} />

export default Spacer
